import * as React from "react";
import type { SVGProps } from "react";
const SvgSwish = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="url(#swish_svg__a)"
      fillRule="evenodd"
      d="M7.606 20.806a9.84 9.84 0 0 0 11.798-2.568c3.499-4.182 2.955-10.416-1.214-13.924l-2.772 3.312c3.257 2.741 3.682 7.611.948 10.878-2.18 2.605-5.768 3.475-8.76 2.302"
      clipRule="evenodd"
    />
    <path
      fill="url(#swish_svg__b)"
      fillRule="evenodd"
      d="M7.606 20.806a9.84 9.84 0 0 0 11.798-2.568 10 10 0 0 0 .955-1.357 8.656 8.656 0 0 0-4.94-9.254c3.256 2.74 3.68 7.61.947 10.877-2.18 2.605-5.768 3.475-8.76 2.302"
      clipRule="evenodd"
    />
    <path
      fill="url(#swish_svg__c)"
      fillRule="evenodd"
      d="M16.105 2.962A9.84 9.84 0 0 0 4.306 5.531C.807 9.713 1.351 15.946 5.52 19.455l2.772-3.313c-3.257-2.74-3.682-7.61-.948-10.878 2.18-2.604 5.768-3.474 8.76-2.302"
      clipRule="evenodd"
    />
    <path
      fill="url(#swish_svg__d)"
      fillRule="evenodd"
      d="M16.105 2.962A9.84 9.84 0 0 0 4.306 5.531a10 10 0 0 0-.955 1.357 8.655 8.655 0 0 0 4.94 9.254C5.036 13.4 4.612 8.53 7.345 5.264c2.18-2.604 5.768-3.474 8.76-2.302"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="swish_svg__a"
        x1={1147.46}
        x2={726.746}
        y1={1045.24}
        y2={209.628}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ef2131" />
        <stop offset={1} stopColor="#fecf2c" />
      </linearGradient>
      <linearGradient
        id="swish_svg__b"
        x1={764.197}
        x2={26.89}
        y1={7.627}
        y2={1280.24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fbc52c" />
        <stop offset={0.264} stopColor="#f87130" />
        <stop offset={0.561} stopColor="#ef52e2" />
        <stop offset={1} stopColor="#661eec" />
      </linearGradient>
      <linearGradient
        id="swish_svg__c"
        x1={292.115}
        x2={695.364}
        y1={717.945}
        y2={1535.64}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#78f6d8" />
        <stop offset={0.266} stopColor="#77d1f6" />
        <stop offset={0.554} stopColor="#70a4f3" />
        <stop offset={1} stopColor="#661eec" />
      </linearGradient>
      <linearGradient
        id="swish_svg__d"
        x1={549.162}
        x2={1280.72}
        y1={1416.17}
        y2={147.901}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#536eed" />
        <stop offset={0.247} stopColor="#54c3ec" />
        <stop offset={0.564} stopColor="#64d769" />
        <stop offset={1} stopColor="#fecf2c" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSwish;
